import { hot } from 'react-hot-loader/root'
import * as React from 'react'
import '@webstyles/index.scss'
import { WebHead, Toasting } from '@huyafed/comp';
import footer from '@webimages/footer.png'
import RichRank from '@webhooks/richRank.tsx'
import DayRank from '@webhooks/dayRank.tsx'
import WholeRank from '@webhooks/wholeRank.tsx'
import Award from '@webhooks/award.tsx'
import Hour from '@webhooks/hour.tsx'
import header from '@webimages/header.png'
import Rule from '@webhooks/rule.tsx'
import {
  getDriverStage,
  StageRsp,
  getDriverRank,
  DriverRankRsp,
  getDriverDayRank,
  DayRankRsp,
  getDriverHourRank,
  HourRankRsp,
  getDriverHourChampion,
  HourChampionRsp,
  getDriverRichRank,
  RichRankRsp,
  getDriverAwardRecord,
  AwardRecordRsp,
  RankItem,
  HourRankItem,
  AwardEvent,
} from '@pubts/fetch'
const { useState, useEffect, useReducer } = React;
interface TabType {
  tabName: string,
  tabCurrent: number,

}
/* 配置tab */
const tabs: TabType[] = [
  {
    tabName: 'tab-1',
    tabCurrent: 1,
  },
  {
    tabName: 'tab-2',
    tabCurrent: 0,
  },
];
const AppWeb: React.FC = () => {
  const [tabList] = useState<TabType[]>(tabs);
  const [tabCurrent, TabCurrent] = useState<number>(0);
  const [iStage, setIStage] = useState<number>(0);
  const [iAreaId, setIArea] = useState<number>(1);

  useEffect(() => {
    getDriverStage(
      {
        iDummy: 0,
        lPid: 0,
      },
    )
      .then((rsp: StageRsp) => {
        // console.log('获取阶段', rsp);
        if (rsp.iStage > 0) {
          setIStage(rsp.iStage);
          TabCurrent(rsp.iStage > 0 ? 1 : 0);
        }
      })
  }, [])

  const dataInit = { DriverRank: [], DriverDayRank: [], DriverHourRank: [], iHour: 0, DriverHourChampion: [], DriverRichRank: [], DriverAwardRecord: [] }
  const [data, dataDispatch] = useReducer(
    (
      prevState: {
        DriverRank: RankItem[],
        DriverDayRank: RankItem[],
        DriverHourRank: HourRankRsp,
        iHour: number,
        DriverHourChampion: HourRankItem[],
        DriverRichRank: RankItem[],
        DriverAwardRecord: AwardEvent[],
      },
      action: { type: string, payload: any },
    ) => {
      switch (action.type) {
        case 'setDriverRank':
          return {
            ...prevState,
            DriverRank: action.payload,
          }
        case 'setDriverDayRank':
          return {
            ...prevState,
            DriverDayRank: action.payload,
          }
        case 'setDriverHourRank':
          return {
            ...prevState,
            DriverHourRank: action.payload,
          }
        case 'setIHour':
          return {
            ...prevState,
            iHour: action.payload,
          }
        case 'setDriverHourChampion':
          return {
            ...prevState,
            DriverHourChampion: action.payload,
          }
        case 'setDriverRichRank':
          return {
            ...prevState,
            DriverRichRank: action.payload,
          }
        case 'setDriverAwardRecord':
          return {
            ...prevState,
            DriverAwardRecord: action.payload,
          }
        default:
          return prevState
      }
    }, dataInit,
  )

  useEffect(() => {
    if (!iStage) return;
    const req = {
      lPid: 0,
      iAreaId,
    }
    getDriverRank(req)
      .then((rsp: DriverRankRsp) => {
        // console.log('老司机总榜单', JSON.stringify(rsp));
        dataDispatch({
          type: 'setDriverRank',
          payload: rsp.vItem.value,
        });
      })

    getDriverDayRank(req)
      .then((rsp: DayRankRsp) => {
        // console.log('老司机天榜', JSON.stringify(rsp));
        dataDispatch({
          type: 'setDriverDayRank',
          payload: rsp.vItem.value,
        });
      })

    getDriverHourRank(req)
      .then((rsp: HourRankRsp) => {
        // console.log('老司机小时榜', JSON.stringify(rsp));
        dataDispatch({
          type: 'setDriverHourRank',
          payload: rsp.vItem.value,
        });
        dataDispatch({
          type: 'setIHour',
          payload: rsp.iHour,
        });
      })

    getDriverHourChampion(req)
      .then((rsp: HourChampionRsp) => {
        // console.log('小时冠军', JSON.stringify(rsp));
        dataDispatch({
          type: 'setDriverHourChampion',
          payload: rsp.vItem.value.reverse(),
        });
      })
  }, [iStage, iAreaId])

  useEffect(() => {
    if (!iStage) return;
    const req = {lPid: 0};
    getDriverRichRank(req)
      .then((rsp: RichRankRsp) => {
        // console.log('神豪榜', JSON.stringify(rsp));
        dataDispatch({
          type: 'setDriverRichRank',
          payload: rsp.vItem.value,
        });
      })
    getDriverAwardRecord(req)
      .then((rsp: AwardRecordRsp) => {
        // console.log('开奖记录', JSON.stringify(rsp));
        dataDispatch({
          type: 'setDriverAwardRecord',
          payload: rsp.vEvents.value,
        });
      })
  }, [iStage])
  return (
    <div id="webapp">
      <WebHead
        image={header}
        video={'https://diy-assets.msstatic.com/hyys/activity/20210126toutu.mp4'}
      />
      <div className='web-content'>
        <ul className='web-tab'>
          {
            tabList.map((item: TabType) => (
              <li
                className={item.tabName + `${tabCurrent === item.tabCurrent ? ' on' : ' off'}`}
                key={item.tabName}
                onClick={
                  (): void => {
                    if (iStage === 0 && item.tabCurrent !== 0) {
                      Toasting({
                        desc: '该赛程暂未开始，敬请期待',
                      });
                      return;
                    }
                    TabCurrent(item.tabCurrent);
                  }
                }
              ></li>
            ))
          }
        </ul>
        {
          tabCurrent === 1 && (
            <>
              <ul className='web-subtab'>
                {
                  [1, 2, 3, 4, 5].map((item: number, index: number) => (
                    <li
                      key={item}
                      className={`web-subtab-${index + 1} ${iAreaId !== (index + 1) ? 'off' : 'on' }`}
                      onClick={
                        () => {
                          setIArea(index + 1);
                        }
                      }
                    />
                  ))
                }
              </ul>
              <div className='topRank'>
                <Award
                  data={data.DriverAwardRecord}
                />
                <Hour
                  data={data.DriverHourRank}
                  data1={data.DriverHourChampion}
                  iHour={data.iHour}
                  color={'white'}
                  selectBackground={'#2582eb'}
                />
              </div>
              <DayRank
                data={data.DriverDayRank}
                count={10}
                loading={false}
                color={'white'}
                selectBackground={'#2582eb'}
              />
              <WholeRank
                data={data.DriverRank}
                count={10}
                loading={false}
                color={'white'}
                selectBackground={'#2582eb'}
              />
              <RichRank
                data={data.DriverRichRank}
                loading={false}
                count={10}
                color={'white'}
                selectBackground={'#2582eb'}
              />
            </>
          )
        }
        {
          tabCurrent === 0 && (
            <Rule url={'https://hd.huya.com/huyaDIYzt/13135/pc/index.html?client=auto'} />
          )
        }
      </div>
      <img
        className='web-foot'
        alt='底部背景'
        src={footer}
      />
    </div>
  )
}

export default hot(AppWeb);
